export const APP_ROUTES = {
  WAITING_ROOM: '/',
  OFFERS: '/tus-cuotas',
  AUTH: '/ingresar',
  AUTH_PARAMS: {
    WITHOUT_TOKEN: '/?error=token',
  },
  ONBOARDING: '/verificacion-datos/user-form',
  FAST_ONBOARDING_STEP_1: '/verificacion-datos/ingresa-tu-dni',
  FAST_ONBOARDING_STEP_2: '/verificacion-datos/informacion-personal',
  SCORE: '/pagos',
  PAYMENT_METHOD: '/pagos/metodo-de-pago',
  PAYMENT_STATUS: '/pagos/estado-de-pago',
  PAYMENT_PLAN: '/pagos/plan-de-pagos',
  INSTALLMENTS: '/prestamo/plan-pagos',
  FREQUENT_QUESTIONS_SCORE: '/prestamo/preguntas-frecuentes',
  PAYMENT: '/prestamo/pago-exito',
  ERROR: '/error',
  CONTINUE_PROCESS: '/continua-tu-proceso',
  LOADING: '/cargando',
  CALCULATE: '/prestamo/procesando',
  FREQUENT_QUESTIONS: '/preguntas-frecuentes',
  ERROR_01: '/error-01',
  ERROR_PAYMENT_02: '/error-payment-02',
  ERRORS: '/errors',
  BIOMETRICS: '/biometria',
  PURCHASELESS_ONBOARDING: '/onboarding',
  COMPLETED_PROFILE: '/perfil-completado',
  VALIDATIONS: '/validaciones',
  NO_AVAILABLE_OFFER: '/validaciones/oferta-no-disponible',
  TRANSACTION_VALIDATE: '/validaciones/transacciones',
  CARD_VALIDATION: '/pagos/agregando-tarjeta',
};
